import { AllocateSingleId } from "../AllocateId";
import { GetMasterTableEntries } from "../GetMasterTableEntries";
import { DeleteFromServer, FetchFromServer, SaveToServer } from "../Post";

const MasterTableName = "GladianceCountryMaster";
const FetchRequestType = "GladianceCountryFetchRequest";

export const GetGladianceCountry = async (Ref) => {
  let payload = { GladianceCountryRefs: [Ref] };
  let td = await FetchFromServer(payload, FetchRequestType, []);
  let resultList = GetMasterTableEntries(td, MasterTableName);
  if (resultList.length > 0) {
    return resultList[0];
  }
  return null;
};

export const SaveGladianceCountry = async (ref, payload, Image) => {
  payload["Ref"] = await AllocateSingleId(ref);
  return await SaveToServer(payload, MasterTableName, Image);
};

export const GetGladianceCountryList = async () => {
  let payload = { GladianceCountryRefs: [] };
  let td = await FetchFromServer(payload, FetchRequestType, []);
  let result = GetMasterTableEntries(td, MasterTableName);
  result = result.sort((a, b) => a.Name.localeCompare(b.Name));
  return result;
};

export const DeleteGladianceCountry = async (payload) => {
  return await DeleteFromServer(payload, MasterTableName);
};
